module.exports = __webpack_public_path__ + "img/MPV_disabled.1fd7887f.svg";